module.exports = __webpack_public_path__ + "static/peercoin-9652a628f2d52b28e9875f57e3a50f7d.png";